import * as React from 'react';
import { makeStyles, Typography, Box, Card, CardContent, Button } from '@material-ui/core';
//import { Icon } from '@mitie/material-ui-extensions';
//import { faQuoteLeft } from '@fortawesome/pro-light-svg-icons';
import { stores } from '../../store';
import { IAskItems, ISiteObject } from '../../types';
import { displayDateTime } from '../../util';

interface IProps {
	ask: IAskItems;
}
const useStyles = makeStyles(theme => ({
	root: {
		minWidth: 275,
	},
	actions: {
		justifyContent: 'flex-end',
	},
	IconStyle: {
		background: theme.palette.warning.main,
		color: theme.palette.background.paper,
		borderRadius: '25px',
		justifyContent: 'space-between',
	},
	closedCard: (props: IProps) => ({
		marginBottom: theme.spacing(2),
		boxShadow: 'none',
	}),
	actionIconButton: {
		width: 40,
		height: 40,
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
		cursor: 'pointer',
		'&:hover': {
			backgroundColor: `${theme.palette.primary.main}0A`,
		},
	},
	ActionButtons: {
		backgroundColor: '#007DBA !important',
		color: '#FFFFFF',
		'&:hover': {
			backgroundColor: '#56b1df !important',
			color: '#FFFFFF',
		},
		'&:focus': {
			outline: 'none',
		},
		'&:focus-visible': {
			border: '2px solid black',
		},
	},
}));

const AskFeedback = (props: IProps) => {
	const classes = useStyles();
	const user = React.useContext(stores.context.user);
	const site = React.useContext(stores.context.site);
	let sitedatanew: any = localStorage.getItem('sitedatalat');
	const routes = React.useContext(stores.context.routes);
	let df: ISiteObject[] = sitedatanew ? JSON.parse(sitedatanew) : site.siteList;
	const siteDataList = sitedatanew ? df : site.siteList;
	const siteName = siteDataList.findIndex((nam: any) => nam.Id === props.ask.SiteName);
	const location = siteName !== -1 ? siteDataList[siteName].Name : '';
	return (
		<Card className={classes.closedCard}>
			<CardContent>
				<div style={{ width: '100%' }}>
					<Box>
						<Typography
							style={{ display: 'inline', fontSize: '24px', fontStyle: 'normal', fontWeight: 'normal' }}
							variant="h6"
							component="p"
							align="left"
						>
							Feedback
						</Typography>
						<Typography
							style={{ display: 'inline', float: 'right', fontSize: '24px', fontStyle: 'normal', fontWeight: 'normal' }}
							variant="h6"
							component="p"
							align="right"
						>
							{displayDateTime(props.ask.CreatedDate)}
						</Typography>
					</Box>
					<Box>
						<Typography
							style={{ display: 'inline', fontSize: '16px' }}
							align="left"
							variant="body2"
							color="textSecondary"
							component="p"
						>
							Address Details
						</Typography>
						<Typography
							style={{ display: 'inline', float: 'right', lineHeight: '1.4', fontSize: '16px' }}
							align="right"
							variant="subtitle2"
						>
							Device Name
						</Typography>
					</Box>

					<div style={{ display: 'inline' }}>
						<div style={{ display: 'inline' }}>
							<Typography
								style={{ display: 'inline', fontSize: '16px' }}
								align="left"
								variant="body2"
								component="p"
								color="textSecondary"
							>
								{location}
							</Typography>
						</div>
						<div style={{ display: 'inline' }}>
							<Typography
								variant="subtitle2"
								style={{ display: 'inline', fontSize: '16px', float: 'right', lineHeight: '1.4' }}
								align="right"
								component="p"
							>
								OS version
							</Typography>
						</div>
					</div>
				</div>
				<Box mt={1} textAlign="Right">
					<Typography
						style={{ display: 'inline', fontSize: '16px', float: 'left' }}
						align="left"
						variant="body2"
						component="p"
						color="textSecondary"
					>
						{`Helpdesk phone`}
					</Typography>
					<Box style={{ display: 'inline' }} justifyContent="right" display="flex" flexDirection="row" mt={1}>
						<Button
							title="Submit Further Feedback"
							id="feedBackButton"
							size="small"
							color="primary"
							variant="contained"
							aria-controls="simple-menu"
							aria-haspopup="true"
							className={classes.ActionButtons}
							onClick={() => {
								const currentFeed = user.sentItems.find((f: any) => f.Id === props.ask.Id);
								currentFeed!.showOpenCard = false;
								routes.navigate(
									{ name: 'feedback' },
									{
										clearParams: true,
									},
								);
							}}
							onKeyDown={e => {
								if (e.key === 'Enter') {
									const currentFeed = user.sentItems.find((f: any) => f.Id === props.ask.Id);
									currentFeed!.showOpenCard = false;
								}
							}}
						>
							Submit Further Feedback
						</Button>
					</Box>
					<Typography variant="body2" style={{ textAlign: 'left', color: '#002855', fontSize: '18px' }}>
						{' Feedback message:   '}
					</Typography>
					<Typography
						variant="subtitle1"
						style={{ textAlign: 'left', color: '#002855', fontSize: '16px', padding: '32px', height: '232px' }}
					>
						{props.ask.Details}
					</Typography>
				</Box>
				<Box my={1}>
					<Typography variant="body2" style={{ textAlign: 'left', color: '#002855', fontSize: '18px' }}>
						Attached Images:
					</Typography>
				</Box>
				<Box display="flex" flexDirection="row">
					{props.ask.Attachments.map((n: any, index: number) =>
						n ? ( // Check if the attachment exists
							<Box key={index} display="flex" flexDirection="column">
								<img src={n} alt="" width="173px" height="173px" />
							</Box>
						) : null,
					)}
				</Box>
			</CardContent>
			{/* <CardActions className={classes.actions}>
			<Button
				size="small"
				color="primary"
				aria-controls="simple-menu"
				aria-haspopup="true"
				onClick={() => {
					const currentFeed = user.userSRs.find((f: any) => f.Id === props.ask.Id);
					currentFeed!.showOpenCard = false;
				}}
			>
				Close
			</Button>
			<Button
				size="small"
				color="primary"
				aria-controls="simple-menu"
				aria-haspopup="true"
				onClick={() => {
					routes.navigate({
						name: 'chatbot',
						params: {
							srId: n.ticketId,
						},
					});
					const currentFeed = user.userSRs.find((f: any) => f.Id === props.ask.Id);
					currentFeed!.showOpenCard = false;
				}}
			>
				Raise query
			</Button>
		</CardActions> */}
		</Card>

		// <Card className={classes.closedCard}>
		// 	<CardContent>
		// 		<Box display="flex" justifyContent="center" p={1} bgcolor="background.paper">
		// 			<Box p={1}>
		// 				<Icon icon={faQuoteLeft} size="3rem" />
		// 			</Box>
		// 		</Box>
		// 		<Box display="flex" justifyContent="center">
		// 			<Typography variant="h6" component="p">
		// 				Feedback
		// 			</Typography>
		// 		</Box>
		// 		<Box textAlign="center" m={1}>
		// 			<Typography variant="caption" display="block" color="textSecondary">
		// 				{displayDateTime(props.ask.CreatedDate)}
		// 			</Typography>
		// 		</Box>
		// 		<Box mt={2}>
		// 			<Typography variant="subtitle2">Location</Typography>
		// 			<Typography variant="caption" color="textSecondary">
		// 				{location}
		// 			</Typography>
		// 		</Box>
		// 		<Box mt={2}>
		// 			<Typography variant="subtitle2">Message</Typography>
		// 			<Typography variant="caption" color="textSecondary">
		// 				{props.ask.Details}
		// 			</Typography>
		// 		</Box>
		// 		<Box my={1}>
		// 			<Typography variant="subtitle2">Attachments</Typography>
		// 		</Box>
		// 		<Box display="flex" flexDirection="row">
		// 			{props.ask.Attachments.map((n: any) => (
		// 				<Box display="flex" flexDirection="column" style={{ margin: 'auto' }}>
		// 					<img src={n} alt="" width="33%" />
		// 				</Box>
		// 			))}
		// 		</Box>
		// 	</CardContent>
		// 	<CardActions className={classes.actions}>
		// 		<Button
		// 			size="small"
		// 			color="primary"
		// 			aria-controls="simple-menu"
		// 			aria-haspopup="true"
		// 			onClick={() => {
		// 				const currentFeed = user.sentItems.find((f: any) => f.Id === props.ask.Id);
		// 				currentFeed!.showOpenCard = false;
		// 			}}
		// 		>
		// 			Close
		// 		</Button>
		// 	</CardActions>
		// </Card>
	);
};

export default AskFeedback;
